import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import ADD_ALERT_MUTATION from "../graphql/AddAlertMutation.gql";
import REMOVE_ALERT_MUTATION from "../graphql/RemoveAlertMutation.gql";

import { AddAlertMutation, AddAlertMutationVariables } from "../graphql/generatedTypes/AddAlertMutation";
import { RemoveAlertMutation, RemoveAlertMutationVariables } from "../graphql/generatedTypes/RemoveAlertMutation";

export default class AlertService {
  constructor(private client: ApolloClient<InMemoryCache>) {
    this.client = client;
  }

  async addAlert({ message, type }: { message: string; type: string }) {
    const result = await this.client.mutate<AddAlertMutation, AddAlertMutationVariables>({
      mutation: ADD_ALERT_MUTATION,
      variables: {
        alert: {
          message,
          type
        }
      }
    });

    if (result.data) {
      const { id } = result.data.addAlert;

      setTimeout(() => {
        this.removeAlert({ id });
      }, this.calcDisplayTime(message.split(" ")?.length || 0));
    }
  }

  async removeAlert({ id }: { id: string }) {
    await this.client.mutate<RemoveAlertMutation, RemoveAlertMutationVariables>({
      mutation: REMOVE_ALERT_MUTATION,
      variables: {
        id
      }
    });
  }

  calcDisplayTime(numOfWords: number): number {
    const displayTimeSeconds = numOfWords / 3;

    return displayTimeSeconds >= 5 ? displayTimeSeconds * 1000 : 5000;
  }
}
